import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { trackButtonClick } from '../lib/analytics';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-screen pt-32 pb-20 overflow-hidden bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50">
      {/* Top Badge */}
      <div className="container mx-auto px-6 mb-12">
        <div className="flex justify-center">
          <div className="inline-flex items-center gap-2 text-orange-400 text-sm font-medium tracking-wider">
            <span>EST. 2020</span>
            <span>|</span>
            <span>Taiwan × The Netherlands</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Left: Text Content */}
            <div className="space-y-8">
              <div>
                <h1 className="text-6xl lg:text-7xl font-serif mb-6">
                  <span className="text-gray-900">Game to </span>
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 via-orange-600 to-amber-700">
                    Growth
                  </span>
                </h1>
                
                <div className="space-y-4">
                  <p className="text-2xl text-gray-700 leading-relaxed">
                    從遊戲到成長 — 喚醒內在智慧能動性，<br />
                    活出富而喜悅的人生
                  </p>
                  
                  <p className="text-lg text-gray-600 italic">
                    Unleashing Intellectual Agency, Amplifying Wealth & Joy.
                  </p>
                  
                  <p className="text-lg text-orange-600 leading-relaxed">
                    我們以遊戲化學習（Game-Based Learning）打造解鎖心智演算法的「覺察沙盒」，陪伴全球企業、教練與新世代青年，在科技高度發達與變局交織的時代，喚醒內在深藏的「高能動性（High Agency）」，真正找回生命與組織的掌控力。
                  </p>
                </div>
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-wrap gap-4">
                <Button 
                  className="rounded-full px-8 py-6 text-lg bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white shadow-lg hover:shadow-xl transition-all duration-300"
                  onClick={() => {
                    trackButtonClick('探索三大版塊', 'hero_section');
                    const element = document.getElementById('services');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  探索三大版塊
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Button>
                <Button 
                  variant="outline"
                  className="rounded-full px-8 py-6 text-lg border-2 border-orange-500 text-orange-600 hover:bg-orange-50 transition-all duration-300"
                  onClick={() => {
                    trackButtonClick('認識創辦人', 'hero_section');
                    navigate('/founder');
                  }}
                >
                  認識創辦人
                </Button>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-3 gap-8 pt-8">
                <div>
                  <div className="text-4xl font-bold text-orange-500 mb-2">300+</div>
                  <div className="text-sm text-gray-600">場次活動</div>
                </div>
                <div>
                  <div className="text-4xl font-bold text-orange-500 mb-2">30+</div>
                  <div className="text-sm text-gray-600">觸及國家</div>
                </div>
                <div>
                  <div className="text-4xl font-bold text-orange-500 mb-2">10,000+</div>
                  <div className="text-sm text-gray-600">受眾人數</div>
                </div>
              </div>
            </div>

            {/* Right: Logo */}
            <div className="flex items-center justify-center">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-br from-orange-200 to-amber-200 rounded-full blur-3xl opacity-30"></div>
                <img 
                  src="https://customer-assets.emergentagent.com/job_cultural-gateway-2/artifacts/8dutq6z7_LOGONEW.png"
                  alt="明悅心創 Ming Yue Culture"
                  className="relative w-full max-w-md h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;